import 'react-micro-modal/dist/index.css';

import React, { useContext, useMemo } from 'react';
import MicroModal from 'react-micro-modal';
import { useHistory } from 'react-router';

import { useAuth } from '../../../auth';
import { Web3StateContext } from '../../../contexts/app-state-context/web3-state/context';
import { ConnectWalletModal } from './connect-wallet';
import { OkModal } from './OkModal.component';

type ModalObject = React.FC<{ hideModal: () => void }>;

// const overridesStyle = {
//   Overlay: {
//     style: {
//       zIndex: 100,
//       background: 'rgba(0, 0, 0, 0.5)',
//       maxWidth: '100%',
//     },
//   },
//   Dialog: {
//     style: {
//       margin: 0,
//       padding: 0,
//       backgroundColor: 'transparent',
//       maxWidth: '100%',
//     },
//   },
// };

const Modal = ({
  isOpen,
  ModalToShow,
  hideModal,
  requireAuth,
  dialogCn,
}: {
  dialogCn: string;
  isOpen: boolean;
  ModalToShow: ModalObject;
  hideModal: () => void;
  requireAuth: boolean;
}) => {
  const { authenticated } = useAuth();
  const { walletDetails } = useContext(Web3StateContext);
  const history = useHistory();

  const overridesStyle = useMemo(
    () => ({
      Overlay: {
        style: {
          zIndex: 100,
          background: 'rgba(0, 0, 0, 0.5)',
          maxWidth: '100%',
        },
      },
      Dialog: {
        className: dialogCn,
        style: {
          margin: 0,
          padding: 0,
          backgroundColor: 'transparent',
          maxWidth: '100%',
        },
      },
    }),
    [dialogCn],
  );

  let ModalNew = ModalToShow;

  if (requireAuth) {
    if (!authenticated) {
      ModalNew = OkModal('Please login first', () => {
        history.push('/login');
      });
    } else if (!walletDetails.address) {
      ModalNew = ConnectWalletModal();
    }
  }

  const closeOutside = () => {
    hideModal();
  };
  return (
    <MicroModal
      open={isOpen}
      overrides={overridesStyle}
      handleClose={closeOutside}
    >
      {() => {
        return <ModalNew hideModal={hideModal} />;
      }}
    </MicroModal>
  );
};

interface AlertState {
  dialogCn: string;
  isOpen: boolean;
  ModalToShow: ModalObject;
  requireAuth: boolean;
}

interface ModalProps {
  setModal: (modal: React.ReactNode, requireAuth?: boolean) => void;
  hideModal: () => void;
}
export function withModal<Props extends ModalProps>(
  WrappedComponent: React.FC<any> | React.ComponentType<Props>,
) {
  return class extends React.Component<
    Omit<Props, keyof ModalProps>,
    AlertState
  > {
    constructor(
      props:
        | Omit<Props, keyof ModalProps>
        | Readonly<Omit<Props, keyof ModalProps>>,
    ) {
      super(props);
      this.state = {
        dialogCn: '',
        isOpen: false,
        ModalToShow: null as unknown as ModalObject,
        requireAuth: false,
      };
    }

    showModal = () => {
      this.setState({ isOpen: true });
      document.body.classList.add('noScroll');
    };

    hideModal = () => {
      this.setState({ isOpen: false });
      document.body.classList.remove('noScroll');
    };

    setModal = (
      ModalToShow: ModalObject,
      requireAuth = false,
      dialogCn = '',
    ) => {
      this.setState({ ModalToShow, requireAuth, dialogCn }, this.showModal);
    };

    render() {
      const { isOpen, ModalToShow } = this.state;
      return (
        <>
          <WrappedComponent
            {...(this.props as Props)}
            setModal={this.setModal}
            hideModal={this.hideModal}
          />
          <Modal
            isOpen={isOpen}
            ModalToShow={ModalToShow}
            dialogCn={this.state.dialogCn}
            hideModal={this.hideModal}
            requireAuth={this.state.requireAuth}
          />
        </>
      );
    }
  };
}
